import { Order, OrderActionType, OrderULResponse } from '@cemex-core/cmx-api';
import { AdtOrderConfirmationActions, AdtOrderConfirmationActionTypes } from '../../actions/order-confirmation.action';
import { PricesPatchResponse } from '@cemex-core/cmx-api/models/prices/prices-patch-res';

export interface OrderConfirmationDetail {
  action: OrderActionType.CREATE | OrderActionType.MODIFY;
  order: Order;
}

/**
 * Order confirmation UL state
 */
export interface OrderConfirmationULState {
  loading: boolean;
  orderConfirmationDraft: OrderULResponse;
  orderConfirmationDetail: OrderConfirmationDetail;
  orderPrices: PricesPatchResponse;
}

/**
 * Initial state of order confirmation UL
 */
export const initialState: OrderConfirmationULState = {
  loading: false,
  orderConfirmationDraft: undefined,
  orderConfirmationDetail: undefined,
  orderPrices: undefined,
};

/**
 * Order confirmation UL reducer
 * @param {OrderConfirmationULState} state Order confirmation UL state
 * @param {OrderConfirmationActions} action Order confirmation actions
 * @returns {OrderConfirmationULState}
 */
export function orderConfirmationULReducer(
  state = initialState,
  action: AdtOrderConfirmationActions,
): OrderConfirmationULState {
  switch (action.type) {
    case AdtOrderConfirmationActionTypes.POST_ORDER_CONFIRMATION:
      return {
        ...state,
        loading: true,
      } as OrderConfirmationULState;
    case AdtOrderConfirmationActionTypes.LOAD_ORDER_CONFIRMATION_DRAFT:
      return {
        ...state,
        loading: Boolean(action.payload),
        orderConfirmationDraft: action.payload,
      } as OrderConfirmationULState;
    case AdtOrderConfirmationActionTypes.LOAD_ORDER_CONFIRMATION_DETAIL:
      return {
        ...state,
        orderConfirmationDetail: action.payload,
      } as OrderConfirmationULState;
    case AdtOrderConfirmationActionTypes.RESET_ORDER_CONFIRMATION:
      return {
        ...initialState,
      };
    case AdtOrderConfirmationActionTypes.LOAD_ORDER_PRICES:
      return {
        ...state,
        orderPrices: action.payload,
      } as OrderConfirmationULState;
    case AdtOrderConfirmationActionTypes.RESET_ORDER_CONFIRMATION_DRAFT:
      return {
        ...state,
        orderConfirmationDraft: undefined,
        orderConfirmationDetail: undefined,
        orderPrices: undefined,
      } as OrderConfirmationULState;
    case AdtOrderConfirmationActionTypes.STOP_LOADING:
      return {
        ...state,
        loading: false,
      } as OrderConfirmationULState;
    case AdtOrderConfirmationActionTypes.RESET_ORDER_CONFIRMATION_DETAIL:
      return {
        ...state,
        orderConfirmationDetail: undefined,
      } as OrderConfirmationULState;
    default:
      return state;
  }
}
